import { createAction } from "@reduxjs/toolkit";

export const ActionType = Object.freeze({
    base: "@@Monitoring/Action/Root",
    reset: "reset"
});

export const resetAllAction = createAction(`${ActionType.base}/${ActionType.reset}`);
export type ResetAllActionType = typeof resetAllAction;